import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b540e2e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b540e2e')) {
      api.createRecord('0b540e2e', component.options)
    } else {
      api.reload('0b540e2e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b540e2e", function () {
      api.rerender('0b540e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/Plants/Plant/Free/index.vue"
export default component.exports